import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/discountsSagas";
import { VIEW_OPTIONS } from "../constants";

const ViewSelector = () => {
  const dispatch = useDispatch();

  const moduleView = useSelector((state) => state.discounts.selectedFilters.moduleView);

  return (
    <MultiSelectDropdown
      options={VIEW_OPTIONS}
      selectedFilters={moduleView}
      placeholder="Select View"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === moduleView.id) return;
        dispatch(actionCreators.updateModuleView(data));
      }}
    />
  );
};

export default ViewSelector;
